<template>
  <b-modal
    :title="title"
    ref="modal"
    centered
    hide-footer
    modal-class="qr-modal"
    @hidden="onClear"
    @shown="onOpenedModal"
  >
    <div class="qr-content">
      <div class="qr-preview">
        <canvas ref="canvas"></canvas>
      </div>
      <p class="qr-hint">Скачайте QR-код в нужном формате для печати или публикации.</p>
      <div class="qr-actions">
        <a
          class="btn btn-primary"
          :class="{ disabled: !dataUrlJpg }"
          :download="fileNameJpg"
          :href="dataUrlJpg"
        >
          Скачать PNG
        </a>
        <a
          class="btn btn-outline-secondary"
          :class="{ disabled: !dataUrlSvg }"
          :download="fileNameSvg"
          :href="dataUrlSvg"
        >
          Скачать SVG
        </a>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import QRCode from 'qrcode';

export default {
  components: {
    BModal,
  },
  data() {
    return {
      url: null,
      title: null,
      dataUrlJpg: null,
      dataUrlSvg: null,
    };
  },
  computed: {
    fileNameJpg() {
      return `QR ${this.title}.jpg`;
    },
    fileNameSvg() {
      return `QR ${this.title}.svg`;
    },
  },
  methods: {
    show(type, item) {
      const baseUrl = process.env.VUE_APP_SITE_URL || 'https://orel-app.ru/';
      this.url = `${baseUrl}?qr=1&t=${type}&id=${item.id}`;
      this.title = item.title;
      this.$refs.modal.show();
    },
    onClear() {
      if (this.dataUrlSvg) URL.revokeObjectURL(this.dataUrlSvg);
      this.title = null;
      this.url = null;
      this.dataUrlJpg = null;
      this.dataUrlSvg = null;
    },
    async onOpenedModal() {
      await QRCode.toCanvas(this.$refs.canvas, this.url, {
        width: 720,
        margin: 2,
      });
      this.generateDataUrl();
    },
    async generateDataUrl() {
      // generate JPG
      this.dataUrlJpg = this.$refs.canvas.toDataURL('image/png');

      // generate SVG
      const svg = await QRCode.toString(this.url, { type: 'svg' });
      const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
      this.dataUrlSvg = URL.createObjectURL(blob);
    },
  },
};
</script>

<style lang="scss">
.qr-modal {
  .modal-content {
    overflow: hidden;
    border: 0;
    border-radius: 18px;
    box-shadow: 0 24px 64px rgba(16, 24, 40, 0.24);
  }

  .modal-header {
    align-items: flex-start;
    padding: 24px 28px 18px;
    border-bottom: 1px solid #eaecf0;
  }

  .modal-title {
    padding-right: 24px;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
  }

  .close {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 8px;
    color: #667085;
    line-height: 1;

    &:hover {
      color: #344054;
      background: #f2f4f7;
    }
  }

  .modal-body {
    padding: 28px;
  }
}

.qr-content {
  text-align: center;
}

.qr-preview {
  display: inline-flex;
  max-width: 100%;
  padding: 14px;
  border: 1px solid #eaecf0;
  border-radius: 14px;
  background: #fff;

  canvas {
    width: 360px !important;
    max-width: 360px;
    height: 360px !important;
    max-height: 360px;
    aspect-ratio: 1;
  }
}

.qr-hint {
  max-width: 420px;
  margin: 18px auto 22px;
  color: #667085;
  font-size: 14px;
}

.qr-actions {
  display: flex;
  justify-content: center;
  gap: 10px;

  .btn {
    min-width: 145px;
  }
}

@media (max-width: 575.98px) {
  .qr-preview canvas {
    width: min(360px, calc(100vw - 92px)) !important;
    height: min(360px, calc(100vw - 92px)) !important;
  }

  .qr-actions {
    flex-direction: column;
  }
}
</style>
